import { config } from './config';

export default function contactForm() {

    document.addEventListener('DOMContentLoaded', function () {
        document.getElementById('form-timestamp').value = Date.now();
    });

    const successDiv = document.getElementById('form-success');
    const successClose = document.getElementById('form-success-close');
    const form = document.getElementById('contact-form-element');

    // Enhanced success message display
    successClose.addEventListener('click', function () {
        // Add transition classes for smooth hiding
        successDiv.classList.add('opacity-0', 'scale-95');
        
        // After a short delay, hide the success message and show the form
        setTimeout(() => {
            successDiv.classList.add('hidden');
            form.classList.remove('hidden');
            
            // Reset opacity and scale for next time
            setTimeout(() => {
                successDiv.classList.remove('opacity-0', 'scale-95');
            }, 300);
        }, 200);
    });

    async function submitForm(event) {
        event.preventDefault();
        const errorDiv = document.getElementById('form-error');
        errorDiv.classList.add('hidden');
        const submitButton = document.getElementById('contact-form-submit');
        submitButton.setAttribute('disabled', true);
        
        // Add loading state to button
        const originalButtonText = submitButton.innerHTML;
        submitButton.innerHTML = '<svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg> Submitting...';
        
        const isValid = validateForm(event);
        if (isValid) {
            // Execute reCAPTCHA verification
            grecaptcha.enterprise.ready(async function () {
                try {
                    const siteKey = config.recaptchaSiteKey;
                    let isDev = false;
                    if (window.location.host.includes("localhost") || window.location.host.includes("127.0.0.1")) {
                        isDev = true;
                    }
                    if (!isDev) {
                        const token = await grecaptcha.enterprise.execute(siteKey, { action: 'contact_form_submit' });
                        document.getElementById('g-recaptcha-response').value = token;
                    } else {
                        document.getElementById('g-recaptcha-response').value = "test";
                    }

                    // Get form data and convert to JSON
                    const formData = new FormData(form);
                    const jsonData = {};

                    // Convert FormData to JSON object
                    formData.forEach((value, key) => {
                        if (key === 'g-recaptcha-response') {
                            jsonData['recaptchaToken'] = value;
                        } else {
                            jsonData[key] = value;
                        }
                    });

                    jsonData['location'] = window.location.href;

                    try {
                        // Send the form data as JSON
                        const response = await fetch(isDev ? 'http://localhost:3006/web/contact' : 'https://console.blueskyapi.com/web/contact', {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                            },
                            body: JSON.stringify(jsonData)

                        });
                        await response.json();
                        if (response.ok) {
                            form.reset();
                            
                            // Enhanced success message display
                            form.classList.add('hidden');
                            successDiv.classList.remove('hidden');
                            
                            // Add a small delay before showing the animation
                            setTimeout(() => {
                                successDiv.classList.add('opacity-100', 'scale-100', 'transition-all', 'duration-500', 'ease-out');
                                successDiv.classList.remove('opacity-0', 'scale-95');
                            }, 10);
                        } else {
                            errorDiv.textContent = 'There was a problem submitting your form. Review your data and try again.';
                            errorDiv.classList.remove('hidden');
                        }
                    } catch (error) {
                        console.error('Error submitting form:', error);
                        errorDiv.textContent = 'There was a problem submitting your form. Please try again later.';
                        errorDiv.classList.remove('hidden');
                    }

                } catch (error) {
                    console.error('reCAPTCHA error:', error);
                    errorDiv.textContent = 'Error verifying reCAPTCHA. Please try again.';
                    errorDiv.classList.remove('hidden');
                } finally {
                    submitButton.removeAttribute('disabled');
                    submitButton.innerHTML = originalButtonText;
                }
            });
        } else {
            submitButton.removeAttribute('disabled');
            submitButton.innerHTML = originalButtonText;
        }
    }
    // Form validation function
    function validateForm(event) {
        event.preventDefault();
        const errorDiv = document.getElementById('form-error');
        errorDiv.classList.add('hidden');

        // Check honeypot field
        const honeypot = document.getElementById('website');
        if (honeypot.value) {
            errorDiv.textContent = 'Form submission error. Please try again.';
            errorDiv.classList.remove('hidden');
            return false;
        }

        // Check if form was submitted too quickly (less than 3 seconds)
        const timestamp = parseInt(document.getElementById('form-timestamp').value);
        const now = Date.now();
        if (now - timestamp < 3000) {
            errorDiv.textContent = 'Form submitted too quickly. Please try again.';
            errorDiv.classList.remove('hidden');
            return false;
        }

        return true;
    }

    window.submitForm = submitForm;
}